import type { GalleryPhoto, Photo } from '@capacitor/camera'
import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { apiFetch } from 'utils/apiFetch'
import { readPhoto } from '../../../../utils/readPhoto'
import { ApiRequestQueue } from './queue'
import type { MetaWithNodeIdentifier } from './queue/types'
import { ApiRequestType } from './queue/types'

export type PreUploadImageMeta = (Photo | GalleryPhoto) & {
  type: routes.ServiceCenterImageUpload.ImageTypes
  linkedRequestId?: string
} & MetaWithNodeIdentifier

export type PreUploadImageResult = { uploadUrl: string; imageUrl: string }

const request = async (meta: PreUploadImageMeta): Promise<PreUploadImageResult> => {
  const { filename, size } = await readPhoto(meta)

  // Get the pre-signed upload url
  const fileUploadUrls = await apiFetch({
    url: '/service-center-image-upload',
    body: {
      contentType: `image/${meta.format}`,
      files: [
        {
          filename,
          size,
        },
      ],
      type: meta.type,
    },
  })

  return fileUploadUrls[0]
}

const callback = async ({ uploadUrl, imageUrl }: PreUploadImageResult, meta: PreUploadImageMeta) => {
  // Queue another request with the pre-signed url (uploadUrl) for the actual upload to S3
  await ApiRequestQueue.createRequest(
    ApiRequestType.UPLOAD_IMAGE,
    {
      ...meta,
      uploadUrl,
      imageUrl,
    },
    { wait: false },
  )
}

export const serviceCenterImagePreUpload = {
  request,
  callback,
}
